import PropTypes from 'prop-types';
import React from 'react';
import { genID } from 'ravenjs/utils/generate';

import SubNavItem from '../SubNavItem';

import SubNavItemsStyled from './SubNavItemsStyled';

const SubNavItems = ({ items }) => (
    <SubNavItemsStyled>
        {items.map(({ name, ...item }) => (
            <SubNavItem key={name || genID()} {...item}>
                {item.title}
            </SubNavItem>
        ))}
    </SubNavItemsStyled>
);

SubNavItems.propTypes = {
    /**
     * List of navigational items
     */
    items: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            /**
             * The title to display for the NavLink
             */
            title: PropTypes.string,
            /**
             * The URL for the NavLink
             */
            to: PropTypes.string,
        })
    ).isRequired,
};

SubNavItems.defaultProps = {};

export default SubNavItems;
